module.exports = __webpack_public_path__ + "img/197.38359145.jpg";